// extracted by mini-css-extract-plugin
export default {"dropDownMenuProfile":"DropDownProfile_dropDownMenuProfile__h0Whf","active":"DropDownProfile_active__zAe-B","inactive":"DropDownProfile_inactive__LhtSu"};